const getSubstringLineNumber = (str: string, substring: string) => {
  str.indexOf(substring)
  const tempString = str.substring(0, str.indexOf(substring))
  return tempString.split('\n').length
}

export { getSubstringLineNumber }
